import React, { useContext } from 'react';
import store from '../../store';
// Custom components
import StoryCard from '../../components/StoryCard';
import AppHeader from '../../components/AppHeader';
// Material components
import { CardActions, Button, Typography } from '@material-ui/core';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { fonts, storyContainer } from '../../assets/jss'
const useStyles = makeStyles((theme) => ({
    storyContainer:{
        ...storyContainer,
        gridTemplateRows: '1fr 10fr 1fr'   
    },
    navigationBtn: {
        border: '1px solid white',
        color: 'white',
        minWidth: 100
    },
    cardWrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    }
}));

function Recent() {
    const classes = useStyles();
    const { storyList, reducers } = useContext(store);
    const [currentNumber, setCurrentNumber] = React.useState(0)

    const handleNavigation = (key) => () => {
        let last = storyList.length - 1;
        if (key === 'previous' && currentNumber !== 0) {
            setCurrentNumber(currentNumber => currentNumber - 1)
            return
        }
        if (key === 'previous' && currentNumber === 0) {
            setCurrentNumber(last)
            return
        }
        if (key === 'next' && currentNumber !== last) {
            setCurrentNumber(currentNumber => currentNumber + 1)
            return;
        }
        if (key === 'next' && currentNumber === last) {
            setCurrentNumber(0)
            return;
        }
    }
    const selectStory = (story) => () => {
        reducers.selectStory(story);
    }

    return (
        <AppHeader>
            <div className={classes.storyContainer}>
                {storyList.length === 0
                    ? <h2 style={fonts.secondary}>There are currently no stories</h2>
                    : <React.Fragment>
                        <div>
                            <h2 style={fonts.secondary}>Recent stories</h2>
                            <Typography component='sub'>Click the story page to edit</Typography>
                        </div>
                        <div className={classes.cardWrapper}
                            onClick={selectStory(storyList[currentNumber])}>
                            <StoryCard story={storyList[currentNumber]} />
                        </div>
                        <CardActions>
                            <Button className={classes.navigationBtn} onClick={handleNavigation('previous')}>Previous</Button>
                            <Button className={classes.navigationBtn} onClick={handleNavigation('next')}>Next</Button>
                        </CardActions>
                    </React.Fragment>
                }
            </div>
        </AppHeader>
    );
}

export default Recent;
